import axios from 'axios';


//new code for testing
const initialToken = localStorage.getItem("selyst_token");


// THIS IS THE IMPORTANT CHANGE: Add 'export' before 'const api'
export const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || "https://api-dev.selyst.com", // Ensure this is your correct backend base URL
  headers: {
    "Content-Type": "application/json",
    // Conditionally add Authorization header if token exists during initial creation
    ...(initialToken ? { Authorization: `Bearer ${initialToken}` } : {}),
  },
});

// Optional: attach token dynamically for each request
api.interceptors.request.use(
  (axiosConfig) => {
    // Renamed 'config' to 'axiosConfig' to avoid conflict with 'config' import
    const currentToken = localStorage.getItem("selyst_token"); // Use 'selyst_token' consistently
    if (currentToken) {
      axiosConfig.headers.Authorization = `Bearer ${currentToken}`;
    } else {
      // Optional: delete Authorization header if no token, to prevent sending an expired/empty one
      delete axiosConfig.headers.Authorization;
    }
    return axiosConfig;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
